import { useCallback, useEffect, useState } from 'react';
import { Paciente } from '../services/mockData';
import { useAuth } from '../contexts/AuthContext';
import { getPacientesForNutritionist } from '../services/dataService';

export function usePacientes() {
  const { user } = useAuth();
  const [data, setData] = useState<Paciente[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [revision, setRevision] = useState(0);
  const refresh = useCallback(() => setRevision(value => value + 1), []);

  useEffect(() => {
    let isMounted = true;

    async function load() {
      if (!user?.uid) {
        if (isMounted) {
          setData([]);
          setLoading(false);
        }
        return;
      }

      setLoading(true);
      setError(null);
      try {
        const pacientes = await getPacientesForNutritionist(user.uid);
        if (isMounted) {
          setData(pacientes);
        }
      } catch (err) {
        if (isMounted) {
          setError('Não foi possível carregar os pacientes.');
          setData([]);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    }

    load();

    return () => {
      isMounted = false;
    };
  }, [user?.uid, revision]);

  return { pacientes: data, loading, error, refresh };
}

